var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { BetslipUtilChannels } from "../dependencies";
import { InternalMsgRouter, ExternalMsgRouter } from "../routers";
import { LibConfig } from "../config";
/**
 * @class
 * @implements {IBsUtil}
 * @classdesc Mediates communication with Betslip
 */
var BsUtil = /** @class */ (function () {
    function BsUtil(retriever, parser) {
        this.betslip = LibConfig.betslip;
        this.retriever = retriever;
        this.parser = parser;
        this.internalMsgRouter = new InternalMsgRouter(LibConfig.internalMsgBus);
        this.internalMsgRouter.attachListeners(this.onMessageReceivedInternal, this);
        this.internalMsgRouter.attachBetslipListeners(this.onMessageReceivedFromBetslip, this);
        if (LibConfig.externalBroadcastEnabled) {
            this.externalMsgRouter = new ExternalMsgRouter(LibConfig.externalMsgBus);
            this.externalMsgRouter.attachListeners(this.onMessageReceivedExternal, this);
        }
    }
    /**
     * @method getInstance
     * @description Get BSUtil instance
     */
    BsUtil.getInstance = function () {
        return BsUtil.instance;
    };
    /**
     * @method add_items
     * @description Handler for BetslipUtilChannels.listen.commands.add_items message
     * @param {BsUtilAddItemsMessage} data Received data
     */
    BsUtil.prototype.add_items = function (data) {
        this.selectionAdded(data);
        this.processMessage(data, this.betslip.addSelection.bind(this.betslip));
    };
    /**
    * @method remove_items
    * @description Handler for BetslipUtilChannels.listen.commands.remove_items message
    * @param {BsUtilRemoveItemsMessage} data Received data
    */
    BsUtil.prototype.remove_items = function (data) {
        this.selectionRemoved(data);
        this.processMessage(data, this.betslip.removeSelection.bind(this.betslip));
    };
    /**
    * @method get_status
    * @description Handler for BetslipUtilChannels.listen.commands.get_status message
    */
    BsUtil.prototype.get_status = function () {
        this.getBetslipStatus(this.betslip.getSelections());
    };
    /**
    * @method clear_slip
    * @description Handler for BetslipUtilChannels.listen.commands.clear_slip message
    */
    BsUtil.prototype.clear_slip = function () {
        this.betslip.clearAll();
    };
    /**
    * @method selectionAdded
    * @description Handler for InternalMessageBusChannels.legacy.betslip.items.add message
    * @param {BsUtilAddItemsMessage} data Received data
    */
    BsUtil.prototype.selectionAdded = function (data) {
        this.internalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Items.added, data);
        this.externalMsgRouter && this.externalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Items.added, data);
    };
    /**
    * @method selectionRemoved
    * @description Handler for InternalMessageBusChannels.legacy.betslip.items.remove message
    * @param {BsUtilRemoveItemsMessage} data Received data
    */
    BsUtil.prototype.selectionRemoved = function (data) {
        this.internalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Items.removed, data);
        this.externalMsgRouter && this.externalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Items.removed, data);
    };
    /**
     * @method getBetslipStatus
     * @description Send BetslipUtilChannels.Broadcast.Status message
     * @param {BsUtilStatusMessage} data Betslip status message
     */
    BsUtil.prototype.getBetslipStatus = function (data) {
        this.internalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Status, data);
        this.externalMsgRouter && this.externalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Status, data);
    };
    /**
    * @method onMessageReceivedInternal
    * @description Process messages from internal msg bus and execute corresponding handler method
    * @param {BsUtilInternalMsgBusMessage<BsUtilItemsMessage>} msg Received message
    */
    BsUtil.prototype.onMessageReceivedInternal = function (msg) {
        var handler = this.internalMsgRouter.listeners[msg.channel + "." + msg.subChannel.join(".")];
        this[handler] && this[handler].apply(this, __spread(msg.data));
    };
    /**
     * @method onMessageReceivedFromBetslip
     * @description Process messages from internal msg bus for FullBetSlip and execute corresponding handler method
     * @param {BsUtilInternalMsgBusMessage<BsUtilItemsMessage>} msg Received message
     */
    BsUtil.prototype.onMessageReceivedFromBetslip = function (msg) {
        var handler = this.internalMsgRouter.betslipListeners[msg.channel + "." + msg.subChannel.join(".")];
        this[handler] && this[handler].apply(this, __spread(msg.data));
    };
    /**
     * @method onMessageReceivedExternal
     * @description Process messages from external msg bus and execute corresponding handler method
     * @param {string} handler Handler method
     * @param {BsUtilItemsMessage} msg Received message
     */
    BsUtil.prototype.onMessageReceivedExternal = function (handler, msg) {
        this[handler] && this[handler](__assign({}, msg));
    };
    /**
     * @method processMessage
     * @description Load data from BFF
     * @param {BsUtilItemsMessage} data
     * @param {Function} handler
     */
    BsUtil.prototype.processMessage = function (data, handler) {
        if (!data.items || !data.items.length) {
            return;
        }
        return this.retriever.loadData(data.items, this.onSuccessCb.bind(this, handler), this.onErrorCb);
    };
    /**
     * @method onErrorCb
     * @description Proccess errors
     * @param {Error} error
     */
    BsUtil.prototype.onErrorCb = function (error) {
        console.error(error);
        // TODO: Send status msg with error
    };
    /**
     * @method onSuccessCb
     * @description Add selections to betslip
     * @param {Function} betslipHandler Betslip handler to execute
     * @param {BsUtilItem[]} betslipData Received data from BFF
     */
    BsUtil.prototype.onSuccessCb = function (betslipHandler, betslipData) {
        var _this = this;
        betslipData.forEach(function (bsItem) {
            return betslipHandler(_this.parser.getLegacySelectionData(bsItem.event, bsItem.market, bsItem.selection));
        });
    };
    return BsUtil;
}());
export { BsUtil };
//# sourceMappingURL=util.js.map